(function (global) {
    define('LNRS/Components/StickyFooter',[
        "jquery","vue"
    ], function ($, Vue) {

        var component = {
            mounted: function () {
                var px = "px";
                var minus = "-";
                this.$el.style.bottom = minus + this.$el.offsetHeight + px;

                window.onscroll = function () {
                    var height = this.$el.offsetHeight;
                    var shyPopupBottom = parseInt(window.getComputedStyle(this.$el, null).getPropertyValue("bottom").replace(/[^-\d\.]/g, ""));

                    if (window.pageYOffset > this.verticalOffsetToStart && shyPopupBottom < 0 && height === -(shyPopupBottom)) {
                        var bodyCurrentPaddingBottom = parseInt(window.getComputedStyle(document.body, null).getPropertyValue("padding-bottom").replace(/[^-\d\.]/g, ""));
                        this.$el.style.bottom = 0 + px;
                        this.$el.classList.remove("invisible");
                        document.body.style.paddingBottom = (bodyCurrentPaddingBottom + height).toString() + px;
                    }

                    if (window.pageYOffset <= this.verticalOffsetToStart && shyPopupBottom >= 0) {
                        this.$el.style.bottom = minus + height + px;
                        document.body.style.paddingBottom = "";
                    }
                }.bind(this);

                $(this.$el).attr("data-ux-state", "loaded").removeAttr("data-ux-args");
            }
        };

        return function initStickyFooter(args) {
            component.el = "#" + args.scope.id;
            component.data = {
                verticalOffsetToStart: args.verticalOffsetToStart
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
